import { useView } from '@/functions';

export default {
    path: '/authorization-code/callback',
    component: useView('docusign/oauth'),
    meta: {
        title: 'Oauth Docusign',
    },
};